export default __webpack_public_path__ + "static/media/mr_biggs.6f3326c0.png";